// TEMPORARY KILL SWITCH (2026-09-17): a critical issue in the new portal means
// everyone must see the legacy UI for a few days.
//
// It lives in its own module ON PURPOSE. When the flag sat inside uiVersion.ts
// the functions there closed over it, so a test could not mock it and three
// suites had to be skipped instead. Importing it from here lets every suite
// keep running against a mocked `false`.
//
// While true: getUiVersion() answers "legacy" for every browser regardless of
// the stored choice, the version banner is not rendered, and App.tsx swaps the
// eager/lazy trees. Flipping this back to false is NOT the whole restore:
// follow the checklist in the TEMPORARY comment at the top of src/App.tsx.
export const LEGACY_ONLY = true;
